import { DrawerCloseButton } from '../drawer-close-button';
import HorizontalWrapper from "../../graphs/horizontal-chart/horizontal-wrapper";
import styles from './right-drawer-content.module.scss';
import { useTranslation } from 'react-i18next';
import { RIGHT_DRAWER } from "@flexo/reducers";
import { useDispatch, useSelector } from "react-redux";

import { formatWeek, formatDay, formatMonth, formatYear, checkItIsToday } from '../../hive-calendar/helpers';


import parse from 'html-react-parser';


export function HorizontalChartDrawerContent({ drawerConfig }: { drawerConfig: any }) {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const calendar = useSelector((state: any) => state.calendar);
  const { hiveCalendar: { selectedDate, selectedTimeSet } } = calendar;


  const getDate = () => {
    let result = '';
    switch (selectedTimeSet) {
      case 'day':
        if (checkItIsToday(selectedDate)) result = t('widgets.calendar.today');
        else result = formatDay(selectedDate);
        break;
      case 'week':
        result = selectedDate[0] ? `${formatWeek(selectedDate)}` : 'Select Week';
        break;
      case 'month':
        result = formatMonth(selectedDate);
        break;
      case 'year':
        result = formatYear(selectedDate);
        break;
      default:
        if (formatDay(selectedDate) === formatDay([new Date(), new Date()] as any))
          result = t('widgets.calendar.yesterday');
        else result = formatDay(selectedDate);
        break;
    }
    return result;
  };
  function closeDrawer() {
    dispatch(RIGHT_DRAWER.HideDrawer());
  }

  return (
    <div style={{ position: 'relative', boxSizing: 'border-box' }}>
      <div className={styles.RightDrawerContent__Title__HorizontalChart}>
        <div>
          <p className={styles.RightDrawerContent__Paragraph}>{parse(drawerConfig?.pageTitle)}</p>
          <DrawerCloseButton onClose={closeDrawer} ariaLabel={t('common.close', { defaultValue: 'Close' })} />
        </div>
        <p className={styles.RightDrawerContent__Title__Custom__Paragraph}>
          {drawerConfig?.pageSubtitle}
          <label>{ ' ' }{getDate()}</label>
          </p>
        

      </div>
      <div className={styles.RightDrawerContent__Body__HorizontalChart}>
        <HorizontalWrapper {...drawerConfig} />

      </div>
    </div>
  );
}